<template>
  <div>
    <div class="row mt-4">
      <div class="col-sm-6">
        <h5 class="mb-3">{{ $t('marketplace.faq.filter_option') }}</h5>
        <b-form v-if="show">
          <b-form-fieldset
            :label="$t('marketplace.faq.title')"
            :label-cols="3"
            :horizontal="true">
            <b-form-input type="text" v-model="filter.title" :placeholder="$t('marketplace.faq.please_enter_title')"></b-form-input>
          </b-form-fieldset>
          <b-form-fieldset
            :label="$t('marketplace.faq.platform')"
            :label-cols="3"
            :horizontal="true">
            <select class="form-control" v-model.trim="filter.platform">
              <option :value="null" key="Please select an platform">Please select an platform</option>
              <option value="all" key="all">All Platform</option>
              <option v-for="(marketplace, index) in marketplaces" :value="marketplace.name" :key="index">{{ marketplace.name }}</option>
            </select>
          </b-form-fieldset>
          <b-form-fieldset
            :label="$t('marketplace.faq.status')"
            :label-cols="3"
            :horizontal="true">
            <select class="form-control" v-model.trim="filter.status">
              <option value="0" key="0">InActive</option>
              <option value="1" key="1">Active</option>
            </select>
          </b-form-fieldset>
          <b-button type="button" size="sm" variant="primary" @click="onSearchForm"><i class="fa fa-search"></i> {{ $t('marketplace.faq.search') }}</b-button>
          <b-button type="reset" size="sm" variant="danger ml-1" @click="onReset"><i class="fa fa-ban"></i> {{ $t('marketplace.faq.reset') }}</b-button>
        </b-form>
      </div><!--col-->
    </div>
  </div>
</template>

<script>

export default {
  name: 'FaqFilters',
  props: {
    filter: {
      type: Object
    },
    fetchMarketplaceFaqs: {
      type: Function
    }
  },
  mounted () {
    this.axios.get('/marketplace/platform').then(response => {
      this.marketplaces = response.data
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      marketplaces: [],
      show: true
    }
  },
  methods: {
    onReset () {
      // evt.preventDefault()
      this.filter.title = ''
      this.filter.platform = null
      this.filter.status = 1
      this.show = false
      this.$nextTick(() => { this.show = true })
    },
    onSearchForm () {
      this.fetchMarketplaceFaqs({
        params: {
          title: this.filter.title,
          platform: this.filter.platform,
          status: this.filter.status,
          page: 1
        }
      })
    }
  }
}
</script>